import {AssetSpecificationApiDto} from "../../api/model/rest";

export default class AssetSpecification {
	constructor(public readonly type: string,
		public readonly label: string,
		public readonly value: string) {}

	static fromJson(json: AssetSpecificationApiDto): AssetSpecification {
		return new AssetSpecification(json.type, json.label, json.value);
	}

	static createEmpty(type: string, label: string, value: string) {
		return new AssetSpecification(type, label, value);
	}

	copy({
		type = this.type,
		label = this.label,
		value = this.value,
	}) {
		return new AssetSpecification(type, label, value);
	}
}

export enum AssetSpecificationType {
	Height = "height",
	Depth = "depth",
	Width = "width",
	Weight = "weight",
	FlowRate = "flow-rate",
	WaterTank = "water-tank",
	WaterOutput = "hot-water-output",
	HeatingOutput = "central-heating-output",
	Efficiency = "efficiency",
	SolarCompatible = "solar-compatible",
}

export enum AssetSpecificationLabel {
	Height = "Height (cm)",
	Depth = "Depth (cm)",
	Width = "Width (cm)",
	Weight = "Weight (kg)",
	FlowRate = "Flow rate (when heating water by 35ºC) in L/min",
	WaterTank = "Internal water tank capacity (L)",
	WaterOutput = "Hot water output (kW)",
	HeatingOutput = "Central heating output (kW)",
	Efficiency = "Efficiency (ErP)",
	SolarCompatible = "Solar compatible",
}